import { render, staticRenderFns } from "./muokkaa-opintoopasta.vue?vue&type=template&id=c153d946&scoped=true&"
import script from "./muokkaa-opintoopasta.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-opintoopasta.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-opintoopasta.vue?vue&type=style&index=0&id=c153d946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c153d946",
  null
  
)

export default component.exports